import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import { Draggable, Droppable } from "react-beautiful-dnd"
import styled from "styled-components"
import { DROP_TYPE_PATH_ITEM } from "../constants"
import * as PathUI from "../ui/PathUI"
import { useEditPathContext } from "./EditPath"
import EditPathAddResource from "./EditPathAddResource"
import EditPathItemControls from "./EditPathItemControls"
import EditPathLessonForm from "./EditPathLessonForm"
import EditPathResource from "./EditPathResource"
import EditPathStep from "./EditPathStep"

const List = styled.ul`
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
  & > li > div {
    padding-top: 10px;
  }
`

const EditPathLesson = ({ pathItem }) => {
  const { editingId, setEditingId } = useEditPathContext()

  if (editingId === pathItem.id) {
    return (
      <EditPathLessonForm
        pathItem={pathItem}
        onClose={() => setEditingId(null)}
      />
    )
  }

  return (
    <PathUI.PathLessonContainer>
      <PathUI.PathLessonHeader>
        <Text.H4 inverted>{pathItem.name}</Text.H4>
        <Text.Meta inverted>{pathItem.description}</Text.Meta>
      </PathUI.PathLessonHeader>
      <EditPathItemControls pathItem={pathItem} inverted />
      <Droppable type={DROP_TYPE_PATH_ITEM} droppableId={pathItem.id + ""}>
        {(provided) => (
          <List ref={provided.innerRef} {...provided.droppableProps}>
            {pathItem.items.map((childItem, index) => (
              <Draggable
                type={DROP_TYPE_PATH_ITEM}
                key={childItem.id}
                draggableId={childItem.id + ""}
                index={index}
              >
                {(provided, snapshot) => (
                  <li>
                    <div
                      ref={provided.innerRef}
                      {...provided.dragHandleProps}
                      {...provided.draggableProps}
                    >
                      {childItem.type === "resource" ? (
                        <EditPathResource pathItem={childItem} layout="list" />
                      ) : childItem.type === "step" ? (
                        <EditPathStep pathItem={childItem} />
                      ) : null}
                    </div>
                    {provided.placeholder}
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
            <li>
              <EditPathAddResource
                index={pathItem.items.length + 1}
                pathId={pathItem.path_id}
                parentId={pathItem.id}
                inverted
              />
            </li>
          </List>
        )}
      </Droppable>
    </PathUI.PathLessonContainer>
  )
}

EditPathLesson.displayName = "EditPathLesson"

EditPathLesson.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default EditPathLesson
